import Component from "../abstracts/Component";
import AccordionMixinComponent from "./mixins/AccordionMixinComponent";

export default class SizeTableComponent extends Component {
  get COMPONENTNAME() {
    return 'SizeTableComponent';
  }
  get SELECTORS() {
    return {
      toggle: '[data-toggle]',
      table: '[data-size-table]',
      moreCta: '[data-more-cta]',
    };
  }

  get CSS() {
    return {
      shown: '--shown',
    }
  }

  constructor(elem) {
    super(elem);
    this.accordion = new AccordionMixinComponent(this.$component);
  }

  readDOM() {
    return {
      toggle: this.$component.querySelector(this.SELECTORS.toggle),
      table: this.$component.querySelector(this.SELECTORS.table),
      moreCta: this.$component.querySelector(this.SELECTORS.moreCta),
    }
  }

  bindEvents() {
    if(this.dom.toggle.dataset.openDefault == "open") {
      this.expand();
    }

    this.dom.toggle.addEventListener('click', evt => {
      this.emit(this.$customEvents.SIZE_GUIDE.toggle);
    });

    this.dom.moreCta.addEventListener('click', () => {
      this.scrollToEndTable();
    });

    const mq = window.matchMedia(`screen and (max-width: 375px)`)
    mq.addEventListener('change', () => this.toggleMoreCta(mq));
    if (mq.matches) this.toggleMoreCta(mq);
  }

  toggleMoreCta() {
    const mq = window.matchMedia(`screen and (max-width: 375px)`)
    const isOverflow = this.dom.table.scrollWidth > this.dom.table.clientWidth;
    this.dom.moreCta.classList.toggle(this.CSS.shown,
      mq.matches && this.isExpanded() && isOverflow
    );
  }

  scrollToEndTable() {
    this.dom.table.scrollTo({
      top: 0, left: this.dom.table.scrollWidth, behavior: 'smooth',
    });
  }

  render() {
    super.render();
    this.accordion.render();

    this.dom = this.readDOM();
    this.bindEvents();
  }

  // API
  expand() {
    this.accordion.expand();
    this.toggleMoreCta();
  }

  collapse() {
    this.accordion.collapse();
    this.toggleMoreCta();
  }

  isExpanded() {
    return this.accordion.isExpanded();
  }
}
